import { BadgeStatus } from 'vcp-common-ui-lib';
import { translate } from '@jsverse/transloco';

export enum OrgStatusesEnum {
    DISABLED = 'DISABLED',
    ENABLED = 'ENABLED',
    DELETED = 'DELETED',
}

export class OrgStatusTypeHelper {
    static getOrgStatusTypeString(status: OrgStatusesEnum): string {
        switch (status) {
            case OrgStatusesEnum.ENABLED:
                return translate('ORG.SEARCH.ENABLED');
            case OrgStatusesEnum.DISABLED:
                return translate('ORG.SEARCH.DISABLED');
            case OrgStatusesEnum.DELETED:
                return translate('ORG.SEARCH.DELETED');
            default:
                return status;
        }
    }

    static getOrgStatusTypeBadgeColor(status: OrgStatusesEnum): BadgeStatus {
        switch (status) {
            case OrgStatusesEnum.ENABLED:
                return 'success';
            case OrgStatusesEnum.DISABLED:
                return 'warning';
            case OrgStatusesEnum.DELETED:
                return 'error';
            default:
                return 'neutral';
        }
    }
}
